const ITEMS = [
  "Terrassement",
  "Location d'engins",
  "Location de véhicules",
  "Appartements meublés",
  "Matériaux BTP",
  "Transport fluvial Maroni",
  "VRD",
  "Maripasoula",
];

export const EditorialMarquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-[#21262D] bg-[#0D1117] py-5 select-none"
    >
      <div className="flex w-max animate-marquee-slow">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-mono text-sm uppercase tracking-[0.3em] text-[#8B949E]"
              >
                <span className="px-6">{item}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#F2541B]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
